import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Line } from 'react-chartjs-2';
import Grid from '@material-ui/core/Grid';
import load from '../img/load.gif'
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const baseUrl = 'https://api.e-stat.go.jp/rest/2.1/app/json/getStatsData?';
const apiKey = process.env.REACT_APP_JPN_STAT_API_KEY;
const params = '&metaGetFlg=Y&cntGetFlg=N&sectionHeaderFlg=1';
const statsDataId = '0003143513';

const useStyles = makeStyles((theme) => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120
	},
	selectEmpty: {
		marginTop: theme.spacing(2)
	}
}));

const getMinMaxValue = (min, max) => {
	let minMaxValueList = [];
	while (min < max) {
		minMaxValueList.push(min);
		min += 5;
	}
	return minMaxValueList;
};

const CircularProgressWithLabel = (props) =>{
	return (
	  <Box position="relative" display="inline-flex">
		<CircularProgress variant="static" {...props} />
		<Box
		  top={0}
		  left={0}
		  bottom={0}
		  right={0}
		  position="absolute"
		  display="flex"
		  alignItems="center"
		  justifyContent="center"
		>
		  <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
			props.value,
		  )}%`}</Typography>
		</Box>
	  </Box>
	);
  }
  
  CircularProgressWithLabel.propTypes = {
	value: PropTypes.number.isRequired,
  };
const App = () => {
	const [ allData, setAllData ] = useState({});
	const [ areaNames, setAreaNames ] = useState({});
	const [ productNames ] = useState({ '0001': '総数', '0002': '食料', '0003': '穀類' });
	const [ timeNames, setTimeNames ] = useState({});
	const [ isLoading, setIsLoading ] = useState(true);
	const minValues = getMinMaxValue(25, 70);
	const maxValues = getMinMaxValue(75, 110);
	const useAPI = (endpoint) => {
		useEffect(() => {
			getData();
		}, []);

		const getData = async () => {
			setIsLoading(true);
			const response = await fetch(endpoint);
			const data = await response.json();
			setAllData(data.GET_STATS_DATA.STATISTICAL_DATA.DATA_INF.VALUE);
			data.GET_STATS_DATA.STATISTICAL_DATA.CLASS_INF.CLASS_OBJ[2].CLASS.map((areaData) => {
				if (areaData['@code'].match(/[0]{3}[0|4-5][0-9]/)) {
					setAreaNames((state) => ({ ...state, [areaData['@code']]: areaData['@name'] }));
				}
			});

			data.GET_STATS_DATA.STATISTICAL_DATA.CLASS_INF.CLASS_OBJ[3].CLASS.map((timeData) => {
				if (timeData['@code'].match(/[0-9]{4}100000/)) {
					setTimeNames((state) => ({ ...state, [timeData['@code']]: timeData['@name'] }));
				}
			});
			setIsLoading(false);
		};
	};

	useAPI(`${baseUrl}appId=${apiKey}&lang=J&statsDataId=${statsDataId}${params}`);

	const classes = useStyles();
	const [ area, setArea ] = useState('00000');
	const [ product, setProduct ] = useState('0001');
	const [ time, setTime ] = useState('2019100000');
	const [ time2, setTime2 ] = useState('2018100000');
	const [ monthLabel, setMonthLabel ] = useState([]);
	const [ dataLabel, setDataLabel ] = useState([]);
	const [ dataLabel2, setDataLabel2 ] = useState([]);
	const [ yearLabel, setYearLabel ] = useState([]);
	const [ dataLabel3, setDataLabel3 ] = useState([]);
	const [ min, setMin ] = useState(30);
	const [ max, setMax ] = useState(105);
	const [ eachYearGraph, setEachYearGraph ] = useState({});
	const [ totalYearGraph, setTotalYearGraph ] = useState({});
	useEffect(
		() => {
			if (Object.keys(allData).length > 0) {
				setDataLabel([]);
				getDataLabel(time, setDataLabel);
				setDataLabel2([]);
				getDataLabel(time2, setDataLabel2);
			}
		},
		[ allData, time, time2, area, product ]
	);

	useEffect(
		() => {
			if (Object.keys(allData).length > 0) {
				setDataLabel3([]);
				setYearLabel([]);
				getDataLabel(false, setDataLabel3);
      }
		},
		[ allData, area, product ]
  );
  
  useEffect(
		() => {
			setEachYearGraph({
				labels: monthLabel,
				datasets: [
					{
						label: `${time.split(100000)[0]} - 消費者物価指数`,
						fill: false,
						lineTension: 0.5,
						backgroundColor: 'rgba(54, 162, 235, 1)',
						borderColor: 'rgba(54, 162, 235, 0.5)',
						borderWidth: 2,
						data: dataLabel
					},
					{
						label: `${time2.split(100000)[0]} - 消費者物価指数`,
						fill: false,
						lineTension: 0.5,
						backgroundColor: 'rgba(41, 241, 195, 1)',
						borderColor: 'rgba(41, 241, 195, 0.5)',
						borderWidth: 2,
						data: dataLabel2
					}
				]
			});
		},
		[ monthLabel, dataLabel, dataLabel2 ]
  );
  
	useEffect(
		() => {
			setTotalYearGraph({
				labels: yearLabel,
				datasets: [
					{
						label: `消費者物価指数`,
						lineTension: 0.1,
						backgroundColor: 'rgba(54, 162, 235, 1)',
						borderColor: 'rgba(54, 162, 235, 0.5)',
						borderWidth: 1,
						fill: false,
						pointRadius: 0.5,
						data: dataLabel3
					}
				]
			});
		},
		[ yearLabel, dataLabel3 ]
	);

	const getDataLabel = (time, setDataLabelFn) => {
		let dict = {};
		if (time) {
			setMonthLabel([]);
			allData.map((data) => {
				if (
					data['@time'].match(time.split(100000)[0]) &&
					data['@area'].match(area) &&
					data['@cat01'].match(product)
				) {
					if (data['@time'].match(/[0-9]{5}[^00000]/)) {
						dict[data['@time']] = data['$'];
					}
				}
			});
			let arr = Object.keys(dict).sort();
			let sorted = {};
			arr.map((key) => {
				sorted[key] = dict[key];
			});
			for (let key in sorted) {
				setMonthLabel((monthLabel) => [ ...monthLabel, key.substr(-2) + '月' ]);
				setDataLabelFn((dataLabel) => [ ...dataLabel, sorted[key] ]);
			}
		} else {
			allData.map((data) => {
				if (
					data['@time'].match(/[0-9]{5}[00000]/) &&
					data['@area'].match(area) &&
					data['@cat01'].match(product)
				) {
					dict[data['@time']] = data['$'];
				}
			});
			let arr = Object.keys(dict).sort();
			let sorted = {};
			arr.map((key) => {
				sorted[key] = dict[key];
			});
			for (let key in sorted) {
				setYearLabel((yearLabel) => [ ...yearLabel, key.substr(0, 4) + '年' ]);
				setDataLabelFn((dataLabel) => [ ...dataLabel, sorted[key] ]);
			}
		}
	};

	const result = (
		<div>
			<FormControl className={classes.formControl}>
				<InputLabel id="area-select-label">地域</InputLabel>
				<Select labelId="area-select-label" value={area} onChange={(e) => setArea(e.target.value)}>
					{Object.keys(areaNames).map((key) => {
						return (
							<MenuItem key={key} value={key}>
								{areaNames[key]}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
			<FormControl className={classes.formControl}>
				<InputLabel id="product-select-label">対象項目</InputLabel>
				<Select labelId="product-select-label" value={product} onChange={(e) => setProduct(e.target.value)}>
					{Object.keys(productNames).map((key) => {
						return (
							<MenuItem key={key} value={key}>
								{productNames[key]}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
			<FormControl className={classes.formControl}>
				<InputLabel id="time-select-label">年</InputLabel>
				<Select labelId="time-select-label" value={time} onChange={(e) => setTime(e.target.value)}>
					{Object.keys(timeNames).map((key) => {
						return (
							<MenuItem key={key} value={key}>
								{timeNames[key]}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
			<FormControl className={classes.formControl}>
				<InputLabel id="time2-select-label">比較対象年</InputLabel>
				<Select labelId="time2-select-label" value={time2} onChange={(e) => setTime2(e.target.value)}>
					{Object.keys(timeNames).map((key) => {
						return (
							<MenuItem key={key} value={key}>
								{timeNames[key]}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
			<FormControl className={classes.formControl}>
				<InputLabel id="min-label">年間 Y軸 最小値</InputLabel>
				<Select labelId="min-label" value={min} onChange={(e) => setMin(e.target.value)}>
					{minValues.map((key) => (
						<MenuItem key={key} value={key}>
							{key}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<FormControl className={classes.formControl}>
				<InputLabel id="max-label">年間 Y軸 最大値</InputLabel>
				<Select labelId="max-label" value={max} onChange={(e) => setMax(e.target.value)}>
					{maxValues.map((key) => (
						<MenuItem key={key} value={key}>
							{key}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<Grid container spacing={3}>
				<Grid item sm={12} md={6}>
					<Line
						data={eachYearGraph}
						options={{
							title: {
								display: true,
								text: '年間消費者物価指数',
								fontSize: 20
							},
							scales: {
								yAxes: [
									{
										ticks: {
											max: max,
											min: min
										}
									}
								]
							}
						}}
					/>
				</Grid>
				<Grid item sm={12} md={6}>
					<Line
						data={totalYearGraph}
						options={{
							title: {
								display: true,
								text: '消費者物価指数',
								fontSize: 20
							}
						}}
					/>
				</Grid>
			</Grid>
		</div>
	);

	  const [progress, setProgress] = useState(10);

	  useEffect(() => {
		const timer = setInterval(() => {
		  setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
		}, 1500);
		return () => {
		  clearInterval(timer);
		};
	  }, []);

	const load = (
		<>
		<h5>消費者物価指数グラフを読み込み中...</h5>
		<CircularProgressWithLabel value={progress} />
		</>
	)

	return <div className="p-5">{isLoading ? load : result}</div>;
};
export default App;
